"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
class CheckBoxColumnConfigManager {
    constructor() {
        this.checkboxAndData = [];
        this.selected = [];
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        // Unused
    }
    click(checkbox) {
        checkbox.setValue(!checkbox.getValue(), true);
    }
    setHeaderCheckbox(checked) {
        this.selected = [];
        for (const checkboxAndDate of this.checkboxAndData) {
            checkboxAndDate.checkbox.setValue(checked, false);
            if (checked) {
                this.selected.push(checkboxAndDate.data);
            }
        }
        this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(this.selected));
    }
    add(data, checkbox) {
        if (this.get(data)) {
            return;
        }
        checkbox.addValueChangeHandler(handler => {
            const value = handler.getValue();
            if (value) {
                this.selected.push(data);
            }
            else {
                const index = this.selected.indexOf(data);
                if (index > -1) {
                    this.selected.splice(index, 1);
                }
            }
            this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(this.selected));
        });
        this.checkboxAndData.push({ data, checkbox });
    }
    get(data) {
        return this.checkboxAndData.find(checkboxAndDate => checkboxAndDate.data === data)?.checkbox;
    }
    remove(data) {
        const index = this.checkboxAndData.findIndex(checkboxAndData => checkboxAndData.data === data);
        if (index > -1) {
            this.checkboxAndData.splice(index, 1);
        }
    }
    areAllCheckboxesSelected() {
        return this.selected.length === this.checkboxAndData.length;
    }
    getSelected() {
        return this.selected;
    }
    clear() {
        this.checkboxAndData = [];
        this.selected = [];
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
}
exports.default = CheckBoxColumnConfigManager;
//# sourceMappingURL=CheckBoxColumnConfigManager.js.map